import React, { useContext } from "react";
import { Tooltip } from "antd";
import style from "./index.module.scss";
import { CourseContext } from "../../../../Store";

export default function CourseHeader() {
    const { course } = useContext(CourseContext);

    return (
        <div className={style.root}>
            <div>
                <h1 className={style.title}>
                    <Tooltip title={course.courseName} placement="bottomLeft">
                        <span>{course.courseName}</span>
                    </Tooltip>
                </h1>

                <div className={style.info}>
                    授课时间 10-28 周四 15:04-18:04
                </div>
            </div>
        </div>
    );
}
